import './App.css';
import logo from './assets/logo.png';

function App() {
  return (
    <div className="App">
      <header className="App-Body">
        <img className="App-Logo" src={logo} alt="Logo" />
        <h1 className="text-fade">Coming Soon</h1>
      </header>
    </div>
  );
}

export default App;
